import script from "./CookieInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./CookieInfoModal.vue?vue&type=style&index=0&id=93804baa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93804baa"]])

export default __exports__